import { useEffect, useRef, useState } from "react";
import { Sparkles, Upload, Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, toastErr, API_BASE } from "@/lib/api";
import { Label } from "./ui";

export const LogoUpload = () => {
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);

  useEffect(() => { api.get("/public/config").then((r) => setUrl(r.data.logo_url)).catch(toastErr); }, []);

  const upload = async (f) => {
    if (!f) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", f);
    try {
      const r = await api.post("/admin/logo", fd);
      setUrl(r.data.logo_url);
      toast.success("Logo updated");
    } catch (e) { toastErr(e); } finally { setBusy(false); }
  };
  const remove = async () => {
    try {
      await api.delete("/admin/logo");
      setUrl(null);
      toast.success("Logo removed");
    } catch (e) { toastErr(e); }
  };

  return (
    <div className="mt-5">
      <Label>Logo / photo</Label>
      <div className="flex items-center gap-4">
        <div className="w-14 h-14 rounded-full bg-slate-900 text-white grid place-items-center overflow-hidden shrink-0 border border-slate-200">
          {url ? <img data-testid="logo-preview" src={`${API_BASE}${url}`} alt="" className="w-full h-full object-cover" /> : <Sparkles size={20} />}
        </div>
        <input ref={fileRef} data-testid="logo-file-input" type="file" accept="image/png,image/jpeg" className="hidden" onChange={(e) => upload(e.target.files[0])} />
        <button data-testid="logo-upload-button" onClick={() => fileRef.current.click()} disabled={busy} className="border border-slate-300 bg-white hover:bg-slate-50 px-4 py-2 rounded-xl text-sm font-medium flex items-center gap-2 disabled:opacity-50">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <Upload size={16} />} {url ? "Replace" : "Upload"}
        </button>
        {url && <button data-testid="logo-remove-button" onClick={remove} className="p-2 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-lg" aria-label="Remove logo"><Trash2 size={16} /></button>}
      </div>
      <p className="mt-2 text-xs text-slate-500">PNG or JPEG, up to 2MB. Shown as a circle in the chat header.</p>
    </div>
  );
};
